import React from 'react';
import { AutoDismissFlag, FlagGroup } from '@atlaskit/flag';
import SuccessIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { G400, R400 } from '@atlaskit/theme/colors';

const addFlag = (value, flags, isSuccess, title) => {
    const flagId = (flags.length) ? flags[flags.length - 1].id + 1 : 1;

    const flag = {
        id: flagId,
        title: title || value,
        icon: isSuccess ? 'success' : 'error',
    };

    if (title) {
        flag.description = value;
    }

    return flags.concat([flag]);
};

export const addSuccessFlag = (flags, message, title = '') => addFlag(message, flags, true, title);

export const addErrorFlag = (flags, message, title = '') => addFlag(message, flags, false, title);

const Flag = ({ flags, setFlags }) => {

    const handleDismiss = () => {
        setFlags(flags.slice(1));
    };

    const FLAG_ICONS = {
        success: <SuccessIcon
            label='Success'
            size='medium'
            primaryColor={G400}
        />,
        error: <ErrorIcon
            label='Error'
            size='medium'
            primaryColor={R400}
        />,
    };

    return (
        <FlagGroup onDismissed={handleDismiss}>
            {flags.map(flag => (
                <AutoDismissFlag
                    id={flag.id}
                    icon={FLAG_ICONS[flag.icon]}
                    key={flag.id}
                    title={flag.title}
                    description={flag.description}
                />
            ))}
        </FlagGroup>
    );
};

export default Flag;
